import { InjectionToken } from '@angular/core';

export const WORKFLOW_INITIALIZER_SERVICE = new InjectionToken('WORKFLOW_INITIALIZER_SERVICE');
